import http from "../http-common";
import authHeader from './auth-header';

class administrationService {
  createInstrumentType(data) {
    return http.post("/administration/instrument_types/create", data, { headers: authHeader() });
  }

  getAllInstrumentTypes() {
    return http.get("/administration/instrument_types", { headers: authHeader() });
  }

  getInstrumentType(InstrumentTypeID) {
    return http.get(`/administration/instrument_types/${InstrumentTypeID}`, { headers: authHeader() });
  }

  updateInstrumentType(InstrumentTypeID, data) {
    return http.put(`/administration/instrument_types/update/${InstrumentTypeID}`, data, { headers: authHeader() });
  }

  deleteInstrumentType(InstrumentTypeID) {
    return http.delete(`/administration/instrument_types/delete/${InstrumentTypeID}`, { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// COUNTER-PARTY LIMITS

  createCounterpartyLimit(data) {
    return http.post("/administration/counterparty_limits/create", data, { headers: authHeader() });
  }

  getAllCounterpartyLimits() {
    return http.get("/administration/counterparty_limits", { headers: authHeader() });
  }

  getAllCounterparties() {
    return http.get("/administration/counterparties", { headers: authHeader() });
  }

  getCounterpartyLimit(id) {
    return http.get(`/administration/counterparty_limits/${id}`, { headers: authHeader() });
  }

  updateCounterpartyLimit(id, data) {
    return http.put(`/administration/counterparty_limits/update/${id}`, data, { headers: authHeader() });
  }

  deleteCounterpartyLimit(id) {
    return http.delete(`/administration/counterparty_limits/delete/${id}`, { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// DEALER LIMITS

  createDealerLimit(data) {
    return http.post("/administration/dealer_limits/create", data, { headers: authHeader() });
  }

  getAllDealerLimits() {
    return http.get("/administration/dealer_limits", { headers: authHeader() });
  }

  getDealerLimit(id) {
    return http.get(`/administration/dealer_limits/${id}`, { headers: authHeader() });
  }

  updateDealerLimit(id, data) {
    return http.put(`/administration/dealer_limits/update/${id}`, data, { headers: authHeader() });
  }

  deleteDealerLimit(id) {
    return http.delete(`/administration/dealer_limits/delete/${id}`, { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TAX RATES

  createTaxRate(data) {
    return http.post("/administration/tax_rates/create", data, { headers: authHeader() });
  }

  getAllTaxRates() {
    return http.get("/administration/tax_rates", { headers: authHeader() });
  }

  getTaxRate(TaxRateID) {
    return http.get(`/administration/tax_rates/${TaxRateID}`, { headers: authHeader() });
  }

  updateTaxRate(TaxRateID, data) {
    return http.put(`/administration/tax_rates/update/${TaxRateID}`, data, { headers: authHeader() });
  }

  deleteTaxRate(TaxRateID) {
    return http.delete(`/administration/tax_rates/delete/${TaxRateID}`, { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TAXES

  createTax(data) {
    return http.post("/administration/taxes/create", data, { headers: authHeader() });
  }

  getAllTaxes() {
    return http.get("/administration/taxes", { headers: authHeader() });
  }

  getTax(TaxID) {
    return http.get(`/administration/taxes/${TaxID}`, { headers: authHeader() });
  }

  updateTax(TaxID, data) {
    return http.put(`/administration/taxes/update/${TaxID}`, data, { headers: authHeader() });
  }

  deleteTax(TaxID) {
    return http.delete(`/administration/taxes/delete/${TaxID}`, { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// MONEY MARKET RATES

  createMMRate(data) {
    return http.post("/administration/mm_rates/create", data, { headers: authHeader() });
  }

  getAllMMRates() {
    return http.get("/administration/mm_rates", { headers: authHeader() });
  }

  updateMMRate(MMRatesId, data) {
    return http.put(`/administration/mm_rates/update/${MMRatesId}`, data, { headers: authHeader() });
  }

  deleteMMRate(MMRatesId) {
    return http.delete(`/administration/mm_rates/delete/${MMRatesId}`, { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// KYC DOCUMENTS

  readKYCDoc(data) {
    return http.post("/administration/kyc_docs/read", data, { headers: authHeader() });
  }

  getKYCDocs() {
    return http.get("/administration/kyc_docs", { headers: authHeader() });
  }

  createComDoc(data) {
    const customHeaders = authHeader()

    customHeaders["Content-Type"] = "multipart/form-data";

    let formData = new FormData();

    formData.append("file", data.file);
    formData.append("json", JSON.stringify(data.json));

    return http.post("/administration/client_com_docs/create", formData, {headers: customHeaders});
  }

  getAllComDocs() {
    return http.get("/administration/client_com_docs", { headers: authHeader() });
  }

  updateComDoc(data) {
    const customHeaders = authHeader()

    customHeaders["Content-Type"] = "multipart/form-data";

    let formData = new FormData();

    formData.append("file", data.file);
    formData.append("json", JSON.stringify(data.json));

    return http.post(`/administration/client_com_docs/update`, formData, {headers: customHeaders});
  }

  deleteComDoc(ClientId, data) {
    return http.post(`/administration/client_com_docs/delete/${ClientId}`, data, { headers: authHeader() });
  }

  createDecDoc(data) {
    const customHeaders = authHeader()

    customHeaders["Content-Type"] = "multipart/form-data";

    let formData = new FormData();

    formData.append("file", data.file);
    formData.append("json", JSON.stringify(data.json));

    return http.post("/administration/client_dec_docs/create", formData, { headers: customHeaders });
  }

  getAllDecDocs() {
    return http.get("/administration/client_dec_docs", { headers: authHeader() });
  }

  updateDecDoc(data) {
    const customHeaders = authHeader()

    customHeaders["Content-Type"] = "multipart/form-data";

    let formData = new FormData();

    formData.append("file", data.file);
    formData.append("json", JSON.stringify(data.json));

    return http.post(`/administration/client_dec_docs/update`, formData, { headers: customHeaders });
  }

  deleteDecDoc(ClientId, data) {
    return http.post(`/administration/client_dec_docs/delete/${ClientId}`, data, { headers: authHeader() });
  }

  createIndDoc(data) {
    const customHeaders = authHeader()

    customHeaders["Content-Type"] = "multipart/form-data";

    let formData = new FormData();

    formData.append("file", data.file);
    formData.append("json", JSON.stringify(data.json));

    return http.post("/administration/client_ind_docs/create", formData, { headers: customHeaders });
  }

  getAllIndDocs() {
    return http.get("/administration/client_ind_docs", { headers: authHeader() });
  }

  updateIndDoc(data) {
    const customHeaders = authHeader()

    customHeaders["Content-Type"] = "multipart/form-data";

    let formData = new FormData();

    formData.append("file", data.file);
    formData.append("json", JSON.stringify(data.json));

    return http.post(`/administration/client_ind_docs/update`, formData, { headers: customHeaders });
  }

  deleteIndDoc(ClientId, data) {
    return http.post(`/administration/client_ind_docs/delete/${ClientId}`, data, { headers: authHeader() });
  }

  createParDoc(data) {
    const customHeaders = authHeader()

    customHeaders["Content-Type"] = "multipart/form-data";

    let formData = new FormData();

    formData.append("file", data.file);
    formData.append("json", JSON.stringify(data.json));

    return http.post("/administration/client_par_docs/create", formData, { headers: customHeaders });
  }

  getAllParDocs() {
    return http.get("/administration/client_par_docs", { headers: authHeader() });
  }

  updateParDoc(data) {
    const customHeaders = authHeader()

    customHeaders["Content-Type"] = "multipart/form-data";

    let formData = new FormData();

    formData.append("file", data.file);
    formData.append("json", JSON.stringify(data.json));

    return http.post(`/administration/client_par_docs/update`, formData, { headers: customHeaders });
  }

  deleteParDoc(ClientId, data) {
    return http.post(`/administration/client_par_docs/delete/${ClientId}`, data, { headers: authHeader() });
  }

  createPenDoc(data) {
    const customHeaders = authHeader()

    customHeaders["Content-Type"] = "multipart/form-data";

    let formData = new FormData();

    formData.append("file", data.file);
    formData.append("json", JSON.stringify(data.json));

    return http.post("/administration/client_pen_docs/create", formData, { headers: customHeaders });
  }

  getAllPenDocs() {
    return http.get("/administration/client_pen_docs", { headers: authHeader() });
  }

  updatePenDoc(data) {
    const customHeaders = authHeader()

    customHeaders["Content-Type"] = "multipart/form-data";

    let formData = new FormData();

    formData.append("file", data.file);
    formData.append("json", JSON.stringify(data.json));

    return http.post(`/administration/client_pen_docs/update`, formData, { headers: customHeaders });
  }

  deletePenDoc(ClientId, data) {
    return http.post(`/administration/client_pen_docs/delete/${ClientId}`, data, { headers: authHeader() });
  }

  createTruDoc(data) {
    const customHeaders = authHeader()

    customHeaders["Content-Type"] = "multipart/form-data";

    let formData = new FormData();

    formData.append("file", data.file);
    formData.append("json", JSON.stringify(data.json));

    return http.post("/administration/client_tru_docs/create", formData, { headers: customHeaders });
  }

  getAllTruDocs() {
    return http.get("/administration/client_tru_docs", { headers: authHeader() });
  }

  updateTruDoc(data) {
    const customHeaders = authHeader()

    customHeaders["Content-Type"] = "multipart/form-data";

    let formData = new FormData();

    formData.append("file", data.file);
    formData.append("json", JSON.stringify(data.json));

    return http.post(`/administration/client_tru_docs/update`, formData, { headers: customHeaders });
  }

  deleteTruDoc(ClientId, data) {
    return http.post(`/administration/client_tru_docs/delete/${ClientId}`, data, { headers: authHeader() });
  }

  createRDCDoc(data) {
    const customHeaders = authHeader()

    customHeaders["Content-Type"] = "multipart/form-data";

    let formData = new FormData();

    formData.append("file", data.file);
    formData.append("json", JSON.stringify(data.json));

    return http.post("/administration/client_rdc_docs/create", formData, { headers: customHeaders });
  }

  getAllRDCDocs() {
    return http.get("/administration/client_rdc_docs", { headers: authHeader() });
  }

  updateRDCDoc(data) {
    const customHeaders = authHeader()

    customHeaders["Content-Type"] = "multipart/form-data";

    let formData = new FormData();

    formData.append("file", data.file);
    formData.append("json", JSON.stringify(data.json));

    return http.post(`/administration/client_rdc_docs/update`, formData, { headers: customHeaders });
  }

  deleteRDCDoc(ClientId, data) {
    return http.post(`/administration/client_rdc_docs/delete/${ClientId}`, data, { headers: authHeader() });
  }

  createPtlDoc(data) {
    const customHeaders = authHeader()

    customHeaders["Content-Type"] = "multipart/form-data";

    let formData = new FormData();

    formData.append("file", data.file);
    formData.append("json", JSON.stringify(data.json));

    return http.post("/administration/client_ptl_docs/create", formData, { headers: customHeaders });
  }

  getAllPtlDocs() {
    return http.get("/administration/client_ptl_docs", { headers: authHeader() });
  }

  updatePtlDoc(data) {
    const customHeaders = authHeader()

    customHeaders["Content-Type"] = "multipart/form-data";

    let formData = new FormData();

    formData.append("file", data.file);
    formData.append("json", JSON.stringify(data.json));

    return http.post(`/administration/client_ptl_docs/update`, formData, { headers: customHeaders });
  }

  deletePtlDoc(ClientId, data) {
    return http.post(`/administration/client_ptl_docs/delete/${ClientId}`, data, { headers: authHeader() });
  }

  createMunDoc(data) {
    const customHeaders = authHeader()

    customHeaders["Content-Type"] = "multipart/form-data";

    let formData = new FormData();

    formData.append("file", data.file);
    formData.append("json", JSON.stringify(data.json));

    return http.post("/administration/client_mun_docs/create", formData, { headers: customHeaders });
  }

  getAllMunDocs() {
    return http.get("/administration/client_mun_docs", { headers: authHeader() });
  }

  updateMunDoc(data) {
    const customHeaders = authHeader()

    customHeaders["Content-Type"] = "multipart/form-data";

    let formData = new FormData();

    formData.append("file", data.file);
    formData.append("json", JSON.stringify(data.json));

    return http.post(`/administration/client_mun_docs/update`, formData, { headers: customHeaders });
  }

  deleteMunDoc(ClientId, data) {
    return http.post(`/administration/client_mun_docs/delete/${ClientId}`, data, { headers: authHeader() });
  }

  createNGODoc(data) {
    const customHeaders = authHeader()

    customHeaders["Content-Type"] = "multipart/form-data";

    let formData = new FormData();

    formData.append("file", data.file);
    formData.append("json", JSON.stringify(data.json));

    return http.post("/administration/client_ngo_docs/create", formData, { headers: customHeaders });
  }

  getAllNGODocs() {
    return http.get("/administration/client_ngo_docs", { headers: authHeader() });
  }

  updateNGODoc(data) {
    const customHeaders = authHeader()

    customHeaders["Content-Type"] = "multipart/form-data";

    let formData = new FormData();

    formData.append("file", data.file);
    formData.append("json", JSON.stringify(data.json));

    return http.post(`/administration/client_ngo_docs/update`, formData, { headers: customHeaders });
  }

  deleteNGODoc(ClientId, data) {
    return http.post(`/administration/client_ngo_docs/delete/${ClientId}`, data, { headers: authHeader() });
  }

  createCCODoc(data) {
    const customHeaders = authHeader()

    customHeaders["Content-Type"] = "multipart/form-data";

    let formData = new FormData();

    formData.append("file", data.file);
    formData.append("json", JSON.stringify(data.json));

    return http.post("/administration/client_cco_docs/create", formData, { headers: customHeaders });
  }

  getAllCCODocs() {
    return http.get("/administration/client_cco_docs", { headers: authHeader() });
  }

  updateCCODoc(data) {
    const customHeaders = authHeader()

    customHeaders["Content-Type"] = "multipart/form-data";

    let formData = new FormData();

    formData.append("file", data.file);
    formData.append("json", JSON.stringify(data.json));

    return http.post(`/administration/client_cco_docs/update`, formData, { headers: customHeaders });
  }

  deleteCCODoc(ClientId, data) {
    return http.post(`/administration/client_cco_docs/delete/${ClientId}`, data, { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// FUND ACCOUNT TYPES

  getAllFundAccountTypes() {
    return http.get("/administration/fund_account_types", { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// CLIENTS

createClient(data) {
  return http.post("/administration/clients/create", data, { headers: authHeader() });
}

getAllClients() {
  return http.get("/administration/clients", { headers: authHeader() });
}

getCurrentValue(ClientID, data) {
  return http.post(`/administration/clients/currentValue/${ClientID}`, data, { headers: authHeader() });
}

getNetValue(ClientID, data) {
  return http.post(`/administration/clients/netValue/${ClientID}`, data, { headers: authHeader() });
}

getEquityCounters() {
  return http.get("/administration/equity_counters", { headers: authHeader() });
}

updateClient(ClientID, data) {
  return http.put(`/administration/clients/update/${ClientID}`, data, { headers: authHeader() });
}

deleteClient(ClientID) {
  return http.delete(`/administration/clients/delete/${ClientID}`, { headers: authHeader() });
}

createClientSignatories(data) {
  const customHeaders = authHeader()

  customHeaders["Content-Type"] = "multipart/form-data";

  let formData = new FormData();

  formData.append("file", data.file);
  formData.append("json", JSON.stringify(data.json));

  return http.post("/administration/client_signatories/create", formData, { headers: customHeaders });
}

getAllClientSignatories() {
  return http.get("/administration/client_signatories", { headers: authHeader() });
}

updateClientSignatory(SignatoryID, data) {
  const customHeaders = authHeader()

  customHeaders["Content-Type"] = "multipart/form-data";

  let formData = new FormData();

  formData.append("file", data.file);
  formData.append("json", JSON.stringify(data.json));

  return http.put(`/administration/client_signatories/update/${SignatoryID}`, formData, { headers: customHeaders });
}

deleteClientSignatory(SignatoryID) {
  return http.delete(`/administration/client_signatories/delete/${SignatoryID}`, { headers: authHeader() });
}

createClientContacts(data) {
  return http.post(`/administration/client_contacts/create`, data, { headers: authHeader() });
}

getAllClientContacts() {
  return http.get("/administration/client_contacts", { headers: authHeader() });
}

updateClientContact(ContactID, data) {
  return http.put(`/administration/client_contacts/update/${ContactID}`, data, { headers: authHeader() });
}

deleteClientContact(ContactID) {
  return http.delete(`/administration/client_contacts/delete/${ContactID}`, { headers: authHeader() });
}

createClientAccount(data) {
  return http.post(`/administration/client_accounts/create`, data, { headers: authHeader() });
}

createClientAccountFees(data) {
  return http.post(`/administration/client_account_fees/create`, data, { headers: authHeader() });
}

getAllClientAccounts() {
  return http.get("/administration/client_accounts", { headers: authHeader() });
}

getAllClientAccountFees() {
  return http.get("/administration/client_account_fees", { headers: authHeader() });
}

getAllDefaultAccountFees() {
  return http.get("/administration/client_default_fees", { headers: authHeader() });
}

getAllIncomeTypes() {
  return http.get("/administration/income_types", { headers: authHeader() });
}

getAllGeneralAccountTypes() {
  return http.get("/administration/general_account_types", { headers: authHeader() });
}

getAllAdminAccountTypes() {
  return http.get("/administration/admin_account_types", { headers: authHeader() });
}

getFeesByCurr(CurrencyID) {
  return http.get(`/administration/fees_by_curr/${CurrencyID}`, { headers: authHeader() });
}

getAccountFrequencies() {
  return http.get("/administration/account_frequencies", { headers: authHeader() });
}

updateClientAccount(AccountID, data) {
  return http.put(`/administration/client_accounts/update/${AccountID}`, data, { headers: authHeader() });
}

updateClientAccountFees(data) {
  return http.post(`/administration/client_account_fees/update`, data, { headers: authHeader() });
}

deleteClientAccount(AccountID) {
  return http.delete(`/administration/client_accounts/delete/${AccountID}`, { headers: authHeader() });
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// FEES MANAGEMENT

  createFee(data) {
    return http.post("/administration/fees_management/create", data, { headers: authHeader() });
  }

  getAllFees() {
    return http.get("/administration/fees_management", { headers: authHeader() });
  }

  getAllApplicationModules() {
    return http.get("/administration/application_modules", { headers: authHeader() });
  }

  getFee(FeesId) {
    return http.get(`/administration/fees_management/${FeesId}`, { headers: authHeader() });
  }

  updateFee(FeesId, data) {
    return http.put(`/administration/fees_management/update/${FeesId}`, data, { headers: authHeader() });
  }

  deleteFee(FeesId) {
    return http.delete(`/administration/fees_management/delete/${FeesId}`, { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TRANSACTION CHARGES

  createTransactionCharge(data) {
    return http.post("/administration/transaction_charges/create", data, { headers: authHeader() });
  }

  getAllTransactionCharges() {
    return http.get("/administration/transaction_charges", { headers: authHeader() });
  }

  getTransactionCharge(TransactionChargeID) {
    return http.get(`/administration/transaction_charges/${TransactionChargeID}`, { headers: authHeader() });
  }

  updateTransactionCharge(TransactionChargeID, data) {
    return http.put(`/administration/transaction_charges/update/${TransactionChargeID}`, data, { headers: authHeader() });
  }

  deleteTransactionCharge(TransactionChargeID) {
    return http.delete(`/administration/transaction_charges/delete/${TransactionChargeID}`, { headers: authHeader() });
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //COUNTER PARTIES

  createCounterParty(data) {
    return http.post("/administration/counter_parties/create", data, { headers: authHeader() });
  }

  getAllCounterParties() {
    return http.get("/administration/counter_parties", { headers: authHeader() });
  }

  updateCounterParty(CounterPartyID, data) {
    return http.put(`/administration/counter_parties/update/${CounterPartyID}`, data, { headers: authHeader() });
  }

  deleteCounterParty(CounterPartyID) {
    return http.delete(`/administration/counter_parties/delete/${CounterPartyID}`, { headers: authHeader() });
  }

////////////////////////////////////////////////////////////////

//CUSTODIANS

  createCustodian(data) {
    return http.post("/administration/custodians/create", data, { headers: authHeader() });
  }

  getAllCustodians() {
    return http.get("/administration/custodians", { headers: authHeader() });
  }

  getAllProfileTypes() {
    return http.get("/administration/profile_types", { headers: authHeader() });
  }

  updateCustodian(CustodianID, data) {
    return http.put(`/administration/custodians/update/${CustodianID}`, data, { headers: authHeader() });
  }

  deleteCustodian(CustodianID) {
    return http.delete(`/administration/custodians/delete/${CustodianID}`, { headers: authHeader() });
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//TRANSACTION CHARGE RATE

  createTransactionchargerate(data) {
    return http.post("/administration/transaction_charge_rates/create", data, { headers: authHeader() });
  }

  getAllTransactionchargerate() {
    return http.get("/administration/transaction_charge_rates", { headers: authHeader() });
  }

  updateTransactionchargerate(TransactionChargeRateId, data) {
    return http.put(`/administration/transaction_charge_rates/update/${TransactionChargeRateId}`, data, { headers: authHeader() });
  }

  deleteTransactionchargerate(TransactionChargeRateId) {
    return http.delete(`/administration/transaction_charge_rates/delete/${TransactionChargeRateId}`, { headers: authHeader() });
  }

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// EQUITIES

  createEquity(data) {
    return http.post("/administration/equities/create", data, { headers: authHeader() });
  }

  getAllEquities() {
    return http.get("/administration/equities", { headers: authHeader() });
  }

  updateEquity(EquityID, data) {
    return http.put(`/administration/equities/update/${EquityID}`, data, { headers: authHeader() });
  }

  deleteEquity(EquityID) {
    return http.delete(`/administration/equities/delete/${EquityID}`, { headers: authHeader() });
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// EQUITY PRICES

  createEquityprice(data) {
    const customHeaders = authHeader()

    customHeaders["Content-Type"] = "multipart/form-data";
  
    let formData = new FormData();
  
    formData.append("file", data.file);
    formData.append("json", JSON.stringify(data.json));

    return http.post("/administration/equityprices/create", formData, { headers: customHeaders });
  }

  getAllEquityprices() {
    return http.get("/administration/equityprices", { headers: authHeader() });
  }

  // updateEquityprice(EquityID, data) {
  //   return http.put(`/administration/equityprices/update/${EquityID}`, data, { headers: authHeader() });
  // }

  // deleteEquityprice(EquityID) {
  //   return http.delete(`/administration/equityprices/delete/${EquityID}`, { headers: authHeader() });
  // }

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// UNLISTED EQUITIES

  createUlEquity(data) {
    return http.post("/administration/equities_ul/create", data, { headers: authHeader() });
  }

  getAllUlEquities() {
    return http.get("/administration/equities_ul", { headers: authHeader() });
  }

  updateUlEquity(EquityID, data) {
    return http.put(`/administration/equities_ul/update/${EquityID}`, data, { headers: authHeader() });
  }

  deleteUlEquity(EquityID) {
    return http.delete(`/administration/equities_ul/delete/${EquityID}`, { headers: authHeader() });
  }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// UNLISTED EQUITY PRICES

  createUlEquityprice(data) {
    const customHeaders = authHeader()

    customHeaders["Content-Type"] = "multipart/form-data";
  
    let formData = new FormData();
  
    formData.append("file", data.file);
    formData.append("json", JSON.stringify(data.json));

    return http.post("/administration/equityulprices/create", formData, { headers: customHeaders });
  }

  getAllUlEquityprices() {
    return http.get("/administration/equityulprices", { headers: authHeader() });
  }

  // updateEquityprice(EquityID, data) {
  //   return http.put(`/administration/equityulprices/update/${EquityID}`, data, { headers: authHeader() });
  // }

  // deleteEquityprice(EquityID) {
  //   return http.delete(`/administration/equityulprices/delete/${EquityID}`, { headers: authHeader() });
  // }

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  getApplicationFunctions() {
    return http.get("/administration/application_functions", { headers: authHeader() });
  }

  getStockExchanges() {
    return http.get("/administration/stock_exchanges", { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// APPLICATION EVENTS

  createEvent(data) {
    return http.post("/administration/application_events/create", data, { headers: authHeader() });
  }

  getAllEvents() {
    return http.get("/administration/application_events", { headers: authHeader() });
  }

  updateEvent(EventId, data) {
    return http.put(`/administration/application_events/update/${EventId}`, data, { headers: authHeader() });
  }

  deleteEvent(EventId) {
    return http.delete(`/administration/application_events/delete/${EventId}`, { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// EVENT MAPPINGS

  createEventMapping(data) {
    return http.post("/administration/event_mappings/create", data, { headers: authHeader() });
  }

  getAllEventMappings() {
    return http.get("/administration/event_mappings", { headers: authHeader() });
  }

  updateEventMapping(EventMappingId, data) {
    return http.put(`/administration/event_mappings/update/${EventMappingId}`, data, { headers: authHeader() });
  }

  deleteEventMapping(EventMappingId) {
    return http.delete(`/administration/event_mappings/delete/${EventMappingId}`, { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// BONDS

  createBond(data) {
    return http.post("/administration/bonds/create", data, { headers: authHeader() });
  }

  getAllBonds() {
    return http.get("/administration/bonds", { headers: authHeader() });
  }

  getCapitalFrequencies() {
    return http.get("/administration/bond_capital_frequency", { headers: authHeader() });
  }

  getBondMaturityDate(data) {
    return http.post("/administration/bond_maturity_date", data, { headers: authHeader() });
  }

  getCouponDates(data) {
    return http.post("/administration/coupon_dates", data, { headers: authHeader() });
  }

  getCapitalDates(data) {
    return http.post("/administration/capital_dates", data, { headers: authHeader() });
  }

  getDaycountBasis() {
    return http.get("/administration/daycount_basis", { headers: authHeader() });
  }

  updateBondStatus(BondID, data) {
    return http.put(`/administration/bonds/update_status/${BondID}`, data, { headers: authHeader() });
  }

  updateBond(BondID, data) {
    return http.put(`/administration/bonds/update/${BondID}`, data, { headers: authHeader() });
  }

  deleteBond(BondID) {
    return http.delete(`/administration/bonds/delete/${BondID}`, { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// PROPERTIES

  createProperty(data) {
    return http.post("/administration/properties/create", data, { headers: authHeader() });
  }

  getAllProperties() {
    return http.get("/administration/properties", { headers: authHeader() });
  }

  updatePropertyStatus(PropertyID, data) {
    return http.put(`/administration/properties/update_status/${PropertyID}`, data, { headers: authHeader() });
  }

  updateProperty(PropertyID, data) {
    return http.put(`/administration/properties/update/${PropertyID}`, data, { headers: authHeader() });
  }

  deleteProperty(PropertyID) {
    return http.delete(`/administration/properties/delete/${PropertyID}`, { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// PROPERTY VALUES

  createPropertyValues(data) {
    return http.post("/administration/property_values/create", data, { headers: authHeader() });
  }

  getAllPropertyValues() {
    return http.get("/administration/property_values", { headers: authHeader() });
  }

  getPropertyPriceHistory(data) {
    return http.post("/administration/property_price_history", data, { headers: authHeader() });
  }
  
  getAllPropertiesForUpload() {
    return http.get("/administration/properties_for_upload", { headers: authHeader() });
  }

  updatePropertyValuesStatus(data) {
    return http.put(`/administration/property_values/update_status`, data, { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// DAILY EXCHANGES

  createDailyExchange(data) {
    return http.post("/administration/daily_exchange/create", data, { headers: authHeader() });
  }

  getAllDailyExchanges() {
    return http.get("/administration/daily_exchange", { headers: authHeader() });
  }

  getAllExchangePairs() {
    return http.get("/administration/exchange_pairs", { headers: authHeader() });
  }

  updateDailyExchange(DailyExchangeId, data) {
    return http.put(`/administration/daily_exchange/update/${DailyExchangeId}`, data, { headers: authHeader() });
  }

  deleteDailyExchange(DailyExchangeId) {
    return http.delete(`/administration/daily_exchange/delete/${DailyExchangeId}`, { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// CONFIRMATION SETTINGS

  getAllConfirmationSettings() {
    return http.get("/administration/confirmation_settings", { headers: authHeader() });
  }

  updateConfirmationSettings(data) {
    return http.post("/administration/confirmation_settings/update", data, { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// DEALERS

  getDealers() {
    return http.get("/administration/dealers", { headers: authHeader() });
  }

  createDealer(data) {
    return http.post("/administration/dealers/create", data, { headers: authHeader() });
  }

  updateDealer(DealerID, data) {
    return http.put(`/administration/dealers/update/${DealerID}`, data, { headers: authHeader() });
  }

  deleteDealer(DealerID) {
    return http.delete(`/administration/dealers/delete/${DealerID}`, { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// UNIT TRUST FUNDS

  getUnitTrustFunds() {
    return http.get("/administration/unit_trust_funds", { headers: authHeader() });
  }

  getUnderlyingPortfolios(Vint, Vvar) {
    return http.get(`/administration/underlying_portfolios/${Vint}/${Vvar}`, { headers: authHeader() });
  }

  getFundClasses(Vint, Vvar) {
    return http.get(`/administration/fund_classes/${Vint}/${Vvar}`, { headers: authHeader() });
  }

  getInvestmentPeriods() {
    return http.get(`/administration/investment_periods`, { headers: authHeader() });
  }

  getPriceQuotation() {
    return http.get(`/administration/price_quotation`, { headers: authHeader() });
  }

  getUnderlyingAssets() {
    return http.get(`/administration/underlying_assets`, { headers: authHeader() });
  }

  getFundCharges(ModuleID, CurrencyID) {
    return http.get(`/administration/fund_charges/${ModuleID}/${CurrencyID}`, { headers: authHeader() });
  }

  createUnitTrustFund(data) {
    return http.post("/administration/unit_trust_funds/create", data, { headers: authHeader() });
  }

  updateUnitTrustFundStatus(UnitTrustFundId, data) {
    return http.put(`/administration/unit_trust_funds/update_status/${UnitTrustFundId}`, data, { headers: authHeader() });
  }

  updateUnitTrustFund(UnitTrustFundId, data) {
    return http.put(`/administration/unit_trust_funds/update/${UnitTrustFundId}`, data, { headers: authHeader() });
  }

  deleteUnitTrustFund(UnitTrustFundId) {
    return http.delete(`/administration/unit_trust_funds/delete/${UnitTrustFundId}`, { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// UNIT TRUST DEALS

  getUnitTrustDeals() {
    return http.get("/administration/unit_trust_deals", { headers: authHeader() });
  }

  getClientGroups() {
    return http.get("/administration/client_groups", { headers: authHeader() });
  }

  getFundNames() {
    return http.get("/administration/fund_names", { headers: authHeader() });
  }

  getClientDetails(ClientGroupId, CurrencyID) {
    return http.get(`/administration/client_details/${ClientGroupId}/${CurrencyID}`, { headers: authHeader() });
  }

  getClientUnitsBalance(data) {
    return http.post(`/administration/client_units_balance`, data, { headers: authHeader() });
  }

  getUnitTrustCharge(FunctionId, AccountId, UnitTrustFundId, CurrentDate, UnitsTransacted, TransactionValue) {
    return http.get(`/administration/unit_trust_charge/${FunctionId}/${AccountId}/${UnitTrustFundId}/${CurrentDate}/${UnitsTransacted}/${TransactionValue}`, { headers: authHeader() });
  }

  createUnitTrustDeal(data) {
    return http.post("/administration/unit_trust_deals/create", data, { headers: authHeader() });
  }

  updateUnitTrustDealStatus(DealNumber, data) {
    return http.put(`/administration/unit_trust_deals/update_status/${DealNumber}`, data, { headers: authHeader() });
  }

  updateUnitTrustDeal(DealNumber, data) {
    return http.put(`/administration/unit_trust_deals/update/${DealNumber}`, data, { headers: authHeader() });
  }

  deleteUnitTrustDeal(DealNumber) {
    return http.delete(`/administration/unit_trust_deals/delete/${DealNumber}`, { headers: authHeader() });
  }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// UNIT DISTRIBUTIONS

  getUnitDistributions() {
    return http.get("/administration/unit_distributions", { headers: authHeader() });
  }

  getIncomeDistribution(DistributionRate, UnitTrustFundId, EffectiveDate, FunctionId, UnitsCash) {
    return http.get(`/administration/income_distribution/${DistributionRate}/${UnitTrustFundId}/${EffectiveDate}/${FunctionId}/${UnitsCash}`, { headers: authHeader() });
  }

  queryDistributionDetails(UnitsDistributionsId) {
    return http.get(`/administration/units_distribution/details/${UnitsDistributionsId}`, { headers: authHeader() });
  }

  createUnitDistribution(data) {
    return http.post("/administration/unit_distributions/create", data, { headers: authHeader() });
  }

  updateUnitDistributionStatus(UnitsDistributionsId, SystemUserID, data) {
    return http.put(`/administration/unit_distributions/update_status/${UnitsDistributionsId}/${SystemUserID}`, data, { headers: authHeader() });
  }

  updateUnitDistribution(UnitsDistributionsId, data) {
    return http.put(`/administration/unit_distributions/update/${UnitsDistributionsId}`, data, { headers: authHeader() });
  }

  deleteUnitDistribution(UnitsDistributionsId) {
    return http.delete(`/administration/unit_distributions/delete/${UnitsDistributionsId}`, { headers: authHeader() });
  }
}

export default new administrationService();